import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2e092cc4"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  class: "el-menu__sub__title"
};
const __default__ = defineComponent({
  name: "myMenu"
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const menuList = ref([{
      id: "1",
      title: "创作空间",
      icon: require("@/assets/img/workplace/config.png"),
      childrens: [{
        id: "1-2",
        title: "最近使用",
        route: {
          path: "/workplace/history"
        }
      }, {
        id: "1-3",
        title: "展项",
        route: {
          path: "/workplace/exibition"
        }
      }, {
        id: "1-4",
        title: "展馆",
        route: {
          // path: "/workplace/exibition",
          path: "/workplace/hall/hallList"
        }
      }, {
        id: "1-5",
        title: "素材库",
        route: {
          path: "/workplace/resource"
        }
      }, {
        id: "1-6",
        title: "与我协作",
        route: {
          path: "/workplace/teamwork"
        }
      }, {
        id: "1-7",
        title: "设计师",
        route: {
          path: "/workplace/designer"
        }
      }]
    }, {
      id: "5",
      title: "AI数字人",
      icon: require("@/assets/img/workplace/number.png"),
      childrens: [{
        id: "5-2",
        title: "数字人配置",
        route: {
          path: "/workplace/digitalConfig"
          // path: "/workplace/404",
        }
      }, {
        id: "5-3",
        title: "人设配置",
        route: {
          path: "/workplace/personnelConfig"
        }
      }, {
        id: "5-4",
        title: "知识库配置",
        route: {
          path: "/workplace/knowledgeBaseConfig"
        }
      }]
    },
    // {
    //   id: "2",
    //   title: "会务中心",
    //   icon: require("@/assets/img/workplace/metting.png"),
    //   childrens: [
    //     {
    //       id: "2-2",
    //       title: "参观预约",
    //       route: {
    //         path: "/workplace/404",
    //       },
    //     },
    //     {
    //       id: "2-3",
    //       title: "活动中心",
    //       route: {
    //         path: "/workplace/404",
    //       },
    //     },
    //     {
    //       id: "2-4",
    //       title: "场地",
    //       route: {
    //         path: "/workplace/404",
    //       },
    //     },
    //   ],
    // },
    // {
    //   id: "3",
    //   title: "营销中心",
    //   icon: require("@/assets/img/workplace/map.png"),
    //   childrens: [
    //     {
    //       id: "3-2",
    //       title: "营销数据",
    //       route: {
    //         path: "/workplace/marketingdata",
    //       },
    //     },
    //     // {
    //     //   id: "3-3",
    //     //   title: "营销雷达",
    //     //   route: {
    //     //     path: "/workplace/404",
    //     //   },
    //     // },
    //     // {
    //     //   id: "3-4",
    //     //   title: "团队数据",
    //     //   route: {
    //     //     path: "/workplace/404",
    //     //   },
    //     // },
    //     // {
    //     //   id: "3-5",
    //     //   title: "传播链条",
    //     //   route: {
    //     //     path: "/workplace/404",
    //     //   },
    //     // },
    //     // {
    //     //   id: "3-6",
    //     //   title: "我的客户",
    //     //   route: {
    //     //     path: "/workplace/404",
    //     //   },
    //     // },
    //     // {
    //     //   id: "3-7",
    //     //   title: "访客中心",
    //     //   route: {
    //     //     path: "/workplace/404",
    //     //   },
    //     // },
    //   ],
    // },
    {
      id: "4",
      title: "设置",
      icon: require("@/assets/img/workplace/edit.png"),
      childrens: [
      // {
      //   id: "4-2",
      //   title: "优惠券",
      //   route: {
      //     path: "/workplace/coupon",
      //   },
      // },
      {
        id: "4-3",
        title: "订单中心",
        route: {
          path: "/workplace/order"
        }
      }
      // {
      //   id: "4-4",
      //   title: "个人账户",
      //   route: {
      //     path: "/workplace/404",
      //   },
      // },
      ]
    }]);

    const route = useRoute();
    function handleOpen(key, keyPath) {}
    function handleClose(key, keyPath) {}
    function handleSelect() {}
    const active = ref("");
    watchEffect(() => {
      const routePath = route.path;
      const routeList = menuList.value.map(x => x.childrens).flat();
      const current = routeList.find(x => {
        return x.route.path == routePath;
      });
      if (current) {
        active.value = current.id;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createBlock(_component_el_menu, {
        id: "workplace-menu",
        onOpen: handleOpen,
        onClose: handleClose,
        "background-color": "#161F3F",
        "text-color": "#fff",
        "active-text-color": "#496EEC",
        style: {
          "border": "none"
        },
        "default-openeds": ['1'],
        router: true,
        onSelect: handleSelect,
        "default-active": _unref(active)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuList), item => {
          return _openBlock(), _createBlock(_component_el_sub_menu, {
            index: item.id,
            key: item.id
          }, {
            title: _withCtx(() => [_createElementVNode("img", {
              src: item.icon,
              alt: "",
              class: "menu-icon"
            }, null, 8, _hoisted_1), _createElementVNode("span", _hoisted_2, _toDisplayString(item.title), 1)]),
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.childrens, child => {
              return _openBlock(), _createBlock(_component_el_menu_item, {
                index: child.id,
                key: child.id,
                route: child.route,
                class: "el-menu__item__title"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(child.title), 1)]),
                _: 2
              }, 1032, ["index", "route"]);
            }), 128))]),
            _: 2
          }, 1032, ["index"]);
        }), 128))]),
        _: 1
      }, 8, ["default-active"]);
    };
  }
});